










import { Prop, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import MenuLayoutPage from "@/custom/page/common/MenuLayoutPage.vue";
import { routerPushSafer } from "@/constants";

const currentPath = '/geodetic-viewer';
const selectMenuKey = 'GeodeticViewer_selectMenu';
@Component({ components: { MenuLayoutPage } })
export default class GeodeticViewer extends Vue {
  menus = [
    { title: 'Cập nhật tiến độ', icon: 'mdi-timelapse' },
    { title: 'VR360', icon: 'mdi-bullseye' },
    { title: 'Trắc địa', icon: 'mdi-map' },
    { title: 'Tải về', icon: 'mdi-download' },
  ];
  @Prop() selectMenuProp;
  selectMenu = parseInt(localStorage.getItem(selectMenuKey) || '2');

  @Watch('selectMenu')
  onSelectMenuChange(val) {
    localStorage.setItem(selectMenuKey, val);
    if (val === 0) {
      routerPushSafer(this.$router, `${currentPath}/timelapse`);
    } else if (val === 1) {
      routerPushSafer(this.$router, `${currentPath}/vr360`);
    } else if (val === 2) {
      routerPushSafer(this.$router, `${currentPath}/geodetic`);
    } else if (val === 3) {
      routerPushSafer(this.$router, `${currentPath}/download-file`);
    }
  }

  mounted() {
    this.selectMenu = this.selectMenuProp ? parseInt(this.selectMenuProp) : this.selectMenu;
  }

  updateMenuSelect(e) {
    this.selectMenu = e;
  }
}
